export default __webpack_public_path__ + "static/media/adventure-golf.aad40b52.jpg";